var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({style:(_vm.positions.style)},'svg',_vm.positions.svgProp,false),[_c('line',_vm._b({staticStyle:{"stroke-width":"2"},style:({stroke: 'green'})},'line',_vm.positions.lineProp,false))])}
var staticRenderFns = []

export { render, staticRenderFns }